<template>
   <div class="container-fluid g-2 web5__rowcard">
    <div class="row" style="min-height: 80px;">      
       <div class="col">
       </div>
     </div>  
     <div class="row">
      <div class="col -2">
       </div>
       <div v-if="IsInFunctionalRoles('MasterAdmin,MonitoringEasy,OnlineCheckEasy,MonitoringProfessional,OnlineCheckProfessional')" class="col-4">
        <div class="card">
          <h5 class="card-header">Monitoring</h5>
          <div class="card-body">
            <h5 class="card-title">Geräte Übersichten und Wartung</h5>
            <p class="card-text">Hier erhalten Sie übersichten über Ihre Geräte.</p>
            <router-link :to="{ name: 'ControlCenter'}">Zum Monitoring</router-link>
          </div>
        </div>
       </div>
       <div v-if="IsInFunctionalRoles('MasterAdmin,DokumentenverwaltungProfessional')" class="col-4">
        <div class="card">
          <h5 class="card-header">Dokumentenverwaltung</h5>
          <div class="card-body">
            <h5 class="card-title">Gebäudepläne</h5>
            <p class="card-text">Überprüfen der aktuellen Gebäudepläne</p>
            <router-link :to="{ name: 'DocumentManagement'}">Anzeigen</router-link>
          </div>
        </div>
       </div>
       <div class="col -2">
       </div>
     </div>
     <div class="row pt-4">
      <div class="col -2">
       </div>
       <div v-if="IsInFunctionalRoles('MasterAdmin,Kundendienst')"  class="col-4">
        <div class="card">
          <h5 class="card-header">Kundendienst</h5>
          <div class="card-body">
            <h5 class="card-title">Störungsmanagement</h5>
            <p class="card-text">Störungen erfassen und Rücksendeschein erzeugen</p>
            <router-link :to="{ name: 'auftrag'}">Melden Sie hier Ihre Störung</router-link>
          </div>
        </div>
       </div>
       <div v-if="IsInFunctionalRoles('MasterAdmin')" class="col-4">
        <div class="card">
          <h5 class="card-header">Rechnungsinfo</h5>
          <div class="card-body">
            <h5 class="card-title">Rechnungsinfo anzeigen</h5>
            <p class="card-text">SOS24Aid-Stammdatenblatt</p>
            <router-link :to="{ name: 'ShowDeviceData'}">Erstellen</router-link>
          </div>
        </div>
       </div>
       <div class="col -2">
       </div>
     </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck
import { defineComponent } from "vue";
import {  ref } from "vue";
import { useStore } from "vuex";
import { AsyncRestClient } from '@/infrastructure/backend/async/AsyncRestClient';
import { Identity } from "@/infrastructure/backend/userIdentity";

import { serializeToJson } from "@/functional/datetimehelper";
import { UserProfile } from "@/infrastructure/backend/userProfile";
import { deepClone } from '@/infrastructure/functional/deepClone';

export default defineComponent({
  name: "HomeView",
  components: {
  },

  setup() {
    const store = new useStore();
    const isReportAllowed = ref(false);

    function IsInFunctionalRoles(functionalRoleName: string) : boolean {
              return UserProfile.IsInFunctionalRoles(functionalRoleName)
    }

    async function isReportRole() {
      const client = AsyncRestClient.Create(true);
      const result = await client
          .getValue()
          .exchangeForComponents<string, any> (process.env.VUE_APP_API + "api/ComponentView/isBerichtRoleAllowed" , serializeToJson({
            userId: Identity.getIdentity().getValue().UserId            
      }));
      if (result.isFailure) return false;
      const temp = deepClone(result.getValue());
      isReportAllowed.value = temp.success;
    }

    isReportRole();

    return {
      isReportAllowed,
      IsInFunctionalRoles
    }
  },



});
</script>
